import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURL, getCategories, logoutUser } from "../redux/Action";

// v1 import
import EditForm from "./v1/EditForm";
import { FEATURED_IMAGE } from "../Public/constants";

const EditBlog = () => {
  const { user, categories, token } = useSelector((state) => state);
  const [formData, setFormdata] = useState({
    title: "",
    featuredImage: "",
  });
  const [content, setContent] = useState("");
  const [author, setauthor] = useState("");
  const [featuredImage, setFeaturedImage] = useState("");
  const [formCheckbox, setFormCheckbox] = useState({});

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getBlog();
    getCategories(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  const getBlog = () => {
    axios
      .get(`${baseURL}/blogs/${id}`)
      .then((res) => {
        console.log(res.data);
        setauthor(res.data.blog.user.email);
        setFormdata({
          title: res.data.blog.title,
          featuredImage: res.data.blog.featuredImage,
        });
        setContent(res.data.blog.body);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckbox = (e) => {
    let { name, value, type, checked } = e.target;
    value = type === "checkbox" ? checked : value;
    setFormCheckbox({
      ...formCheckbox,
      [name]: value,
    });
  };

  const submitBlog = (e) => {
    e.preventDefault();
    const categories_array = [];
    for (let x in formCheckbox) {
      if (formCheckbox[x] === true) {
        categories_array.push(x);
      }
    }
    const payload = {
      ...formData,
      body: content,
      categories_array,
      softDelete: false,
      featuredImage: featuredImage || FEATURED_IMAGE,
    };

    const toastId = toast.loading("Updating...", { theme: "dark" });
    axios
      .put(`${baseURL}/blogs/${id}`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Updated Successfully",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        navigate("/blogs", { replace: true });
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "Something went wrong",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });

        if (err.response && err.response.status === 401) {
          toast.update(toastId, {
            render: "Session Expired. Please Login Again",
            type: "error",
            isLoading: false,
            autoClose: 2000,
            closeOnClick: true,
          });
          logoutUser(dispatch);
        }
      });
  };

  if (author && author !== user.user.email) {
    return <Navigate to={`/blogs/${id}`} />;
  }

  return (
    <div className="min-h-screen bg-gray-50/50 dark:bg-transparent pb-24 mt-[73px]">
      <form onSubmit={submitBlog}>
        <EditForm
          handleChange={handleChange}
          handleCheckbox={handleCheckbox}
          formData={formData}
          content={content}
          setContent={setContent}
          categories={categories}
          setFeaturedImage={setFeaturedImage}
        />
      </form>
    </div>
  );
};

export default EditBlog;
